import PropTypes from 'prop-types';

import CustomerOrderAmountSection from '#/modules/crmMgmt/customerOrder/components/CustomerOrderAmountSection';
import CustomerOrderCommandBar from '#/modules/crmMgmt/customerOrder/components/CustomerOrderCommandBar';
import CustomerOrderDetailTabs from '#/modules/crmMgmt/customerOrder/components/CustomerOrderDetailTabs';
import CustomerOrderMainInfoCard from '#/modules/crmMgmt/customerOrder/components/CustomerOrderMainInfoCard';
import CustomerOrderSnapshotSection from '#/modules/crmMgmt/customerOrder/components/CustomerOrderSnapshotSection';

const CustomerOrderBlock = ({ detail, onRefetch, showActions = false }) => (
  <div className="grid grid-cols-1 gap-4 2xl:grid-cols-2">
    <CustomerOrderMainInfoCard
      detail={detail}
      actions={
        showActions ? (
          <CustomerOrderCommandBar
            key={`${detail.id}-${detail.record?.updatedAt ?? ''}`}
            detail={detail}
            onRefetch={onRefetch}
          />
        ) : null
      }
      containerClassName="2xl:col-span-2"
    />
    <CustomerOrderAmountSection detail={detail} />
    <CustomerOrderSnapshotSection detail={detail} />
    <CustomerOrderDetailTabs detail={detail} onRefetch={onRefetch} />
  </div>
);

CustomerOrderBlock.propTypes = {
  detail: PropTypes.object.isRequired,
  onRefetch: PropTypes.func,
  showActions: PropTypes.bool,
};

export default CustomerOrderBlock;
